/* Nuralis Soursop Daily Drops — document-scoped runtime for the modular PDP.
   Boot-guarded, null-guarded, config-driven 1/2/3 offer (pack 1 preselected),
   gallery + zoom, scroll-driven science scenes, formula leader lines, comparison
   selector, metric counters, fallback-CTA sticky, header cart bag. Add-to-cart wires
   straight to the Ascendify cart drawer (no preview dialog) + live badge sync. */
(() => {
  'use strict';
  if (window.__soursopLander) return; window.__soursopLander = true;

  /* Header cart bag → always open the side cart, never /cart (SOP 0c) */
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('[data-np-cart]'); if (!a) return;
    const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (drawer) { e.preventDefault(); if (typeof drawer.open === 'function') drawer.open(); else drawer.classList.add('active', 'is-open', 'open'); const d = drawer.closest && drawer.closest('details'); if (d) d.open = true; }
  });

  const boot = () => {
    const $ = (s, r = document) => r.querySelector(s);
    const $$ = (s, r = document) => [...r.querySelectorAll(s)];
    const on = (el, ev, fn, o) => el && el.addEventListener(ev, fn, o);
    const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');

    const cfgEl = $('[data-product-config]');
    const config = cfgEl ? (() => { try { return JSON.parse(cfgEl.textContent); } catch (e) { return null; } })() : null;
    const packs = (config && config.packs) || [];
    const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (config && config.currency) || 'USD' }).format(n / 100);
    const cfgByCount = c => packs.find(p => p.count === c) || {};
    const availCfg = c => { const p = cfgByCount(c); return p && p.variantId && p.available; };
    let selected = 1;

    /* ---- price refresh from live variants (leave design defaults when no variant) ---- */
    const refresh = () => {
      packs.forEach(p => {
        if (!p.variantId) return;
        $$(`[data-total="${p.count}"]`).forEach(e => e.textContent = money(p.price));
        $$(`[data-unit="${p.count}"]`).forEach(e => e.textContent = money(Math.floor(p.price / p.count)) + ' each');
        $$(`[data-compare="${p.count}"]`).forEach(e => { if (p.compare > p.price) { e.textContent = money(p.compare); e.hidden = false; } else { e.hidden = true; } });
        $$(`[data-pack-input][data-count="${p.count}"]`).forEach(i => { i.disabled = !p.available; });
      });
    };

    const summaryText = count => {
      const inp = $(`[data-pack-input][data-count="${count}"]`);
      const cfg = cfgByCount(count);
      const days = (inp && inp.dataset.days) || cfg.days || '';
      const totalEl = $(`[data-total="${count}"]`);
      const total = cfg.variantId ? money(cfg.price) : (totalEl ? totalEl.textContent.trim() : '');
      return `${count} bottle${count > 1 ? 's' : ''} · ${days}-day supply · ${total} total`;
    };

    const selectPack = count => {
      if (!count) return; selected = count;
      $$('[data-pack-input]').forEach(i => {
        const on_ = Number(i.dataset.count) === count; i.checked = on_;
        const lab = i.closest('.pack'); if (lab) lab.classList.toggle('selected', on_);
      });
      $$('.selection').forEach(e => e.textContent = summaryText(count));
    };
    $$('[data-pack-input]').forEach(i => on(i, 'change', () => selectPack(Number(i.dataset.count))));

    /* ---- subscription plan (SOP 0d) ---- */
    const sellingPlan = () => {
      const sub = $$('[data-sub-input]').find(x => x.checked);
      if (sub && sub.value === 'subscribe') { const el = $('[data-selling-plan]'); const id = el && el.getAttribute('data-selling-plan'); return (id && /^\d+$/.test(id)) ? Number(id) : null; }
      return null;
    };

    /* ---- gallery (1-indexed slides, thumbnails swap the main image) ---- */
    const frame = $('.gallery-frame'), main = $('.gallery-main');
    let slide = 1;
    const thumbImg = n => { const b = $(`[data-slide="${n}"] img`); return b || null; };
    const setSlide = n => {
      if (!main) return; const count = $$('[data-slide]').length || 1;
      slide = ((n - 1 + count) % count) + 1;
      const t = thumbImg(slide); if (t) { main.src = t.src; main.alt = t.alt; }
      $$('[data-slide]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.slide) === slide)));
    };
    $$('[data-slide]').forEach(b => on(b, 'click', () => setSlide(Number(b.dataset.slide))));
    on($('.gallery-prev'), 'click', () => setSlide(slide - 1));
    on($('.gallery-next'), 'click', () => setSlide(slide + 1));
    on(frame, 'keydown', e => { if (e.key === 'ArrowRight') { e.preventDefault(); setSlide(slide + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); setSlide(slide - 1); } });
    if (frame) { let tx = 0; on(frame, 'touchstart', e => tx = e.changedTouches[0].clientX, { passive: true }); on(frame, 'touchend', e => { const d = e.changedTouches[0].clientX - tx; if (Math.abs(d) > 45) setSlide(slide + (d < 0 ? 1 : -1)); }, { passive: true }); }
    on($('.zoom-image'), 'click', () => { const d = $('#image-dialog'); if (!d || !main) return; const im = $('img', d); if (im) { im.src = main.src; im.alt = main.alt; } if (d.showModal) d.showModal(); });

    /* ---- dialogs ---- */
    $$('.facts-open').forEach(b => on(b, 'click', () => { const d = $('#facts-dialog'); if (d && d.showModal) d.showModal(); }));
    $$('.dialog-close,.dialog-done').forEach(b => on(b, 'click', () => { const d = b.closest('dialog'); if (d) d.close(); }));
    $$('dialog').forEach(d => on(d, 'click', e => { if (e.target === d) { const r = d.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close(); } }));

    /* ---- add to cart → Ascendify drawer ---- */
    function swapDrawer(dest, html) {
      if (!dest || !html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('cart-drawer') || doc.querySelector('.shopify-section');
      if (fresh && fresh.innerHTML.trim()) { if (fresh.tagName && fresh.tagName.toLowerCase() === 'cart-drawer') [...fresh.attributes].forEach(a => { try { dest.setAttribute(a.name, a.value); } catch (e) {} }); dest.innerHTML = fresh.innerHTML; }
    }
    let busy = false;
    const buy = async (btn) => {
      const inp = $(`[data-pack-input][data-count="${selected}"]`) || $('[data-pack-input]:checked');
      const vid = inp && inp.value;
      if (!vid || !/^\d+$/.test(vid)) {
        const url = (config && config.productUrl) || ROOT + 'cart';
        location.assign(url); return;
      }
      if (busy) return; busy = true;
      const label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding your pack…'; }
      $$('[data-cart-error]').forEach(e => e.hidden = true);
      const item = { id: Number(vid), quantity: 1, properties: { Supply: (inp.dataset.days || '') + ' days' } };
      const plan = sellingPlan(); if (plan) item.selling_plan = plan;
      try {
        const add = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) });
        const res = await add.json(); if (!add.ok) throw new Error(res.description || 'Your pack could not be added. Please try again.');
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          const data = await (await fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble')).json();
          swapDrawer(drawer, data['cart-drawer']);
          const bub = document.getElementById('cart-icon-bubble'); if (bub && data['cart-icon-bubble']) { const fb = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html').getElementById('cart-icon-bubble'); if (fb) bub.innerHTML = fb.innerHTML; }
          syncCartCount();
          if (typeof drawer.open === 'function') drawer.open(); else drawer.classList.add('active', 'is-open', 'open');
        } else { location.assign(ROOT + 'cart'); return; }
      } catch (err) { $$('[data-cart-error]').forEach(e => { e.textContent = err.message; e.hidden = false; }); }
      finally { busy = false; if (btn) { btn.disabled = false; btn.innerHTML = label; } }
    };
    $$('.add-cart,[data-buy]').forEach(b => on(b, 'click', e => { e.preventDefault(); buy(b); }));

    refresh();
    const req = new URL(location.href).searchParams.get('variant');
    const byReq = packs.find(p => String(p.variantId) === req && p.variantId);
    selectPack(byReq ? byReq.count : 1);

    /* ---- comparison selector ---- */
    const selector = $('#competitor-select');
    if (selector) {
      const mobile = matchMedia('(max-width:600px)');
      const update = () => { const n = Number(selector.value); $$('.compare-table [data-col]').forEach(e => { e.style.display = (mobile.matches && Number(e.dataset.col) !== 0 && Number(e.dataset.col) !== n) ? 'none' : ''; }); };
      on(selector, 'change', update); mobile.addEventListener('change', update); update();
    }

    /* ---- formula leader lines ---- */
    const scene = $('.formula-scene');
    if (scene) {
      const svg = $('.formula-leaders'), labels = $$('.formula-labels>div');
      const starts = [[.522, .60], [.526, .64], [.495, .681]];
      const align = () => {
        if (!svg) return; const sr = scene.getBoundingClientRect();
        labels.forEach((label, i) => {
          const r = label.getBoundingClientRect(), line = $$('line', svg)[i], dot = $$('circle', svg)[i];
          if (!line || !dot || !starts[i]) return;
          line.setAttribute('x1', starts[i][0] * 1000); line.setAttribute('y1', starts[i][1] * 1000);
          line.setAttribute('x2', (r.left - sr.left) / sr.width * 1000); line.setAttribute('y2', (r.top - sr.top + 1) / sr.height * 1000);
          dot.setAttribute('cx', starts[i][0] * 1000); dot.setAttribute('cy', starts[i][1] * 1000);
        });
      };
      on(window, 'resize', align); on(window, 'load', align);
      if (window.ResizeObserver) new ResizeObserver(align).observe(scene);
      align();
    }

    /* ---- science: scroll-driven scenes + motion toggle ---- */
    const track = $('.science-track'), stage = $('.science-stage');
    let scienceVisible = false;
    if (track && stage) {
      const videos = $$('.science-media video'), toggle = $('.motion-toggle');
      let chapter = -1, paused = reduce.matches;
      const playActive = () => {
        videos.forEach((v, i) => { if (i === chapter && scienceVisible && !paused && !document.hidden) { const p = v.play(); if (p) p.catch(() => {}); } else v.pause(); });
        if (toggle) { toggle.textContent = paused ? 'Play' : 'Pause'; toggle.setAttribute('aria-label', paused ? 'Play science animation' : 'Pause science animation'); }
      };
      const activate = n => {
        if (n === chapter) return; chapter = n;
        videos.forEach((v, i) => { v.classList.toggle('active', i === n); v.setAttribute('aria-hidden', String(i !== n)); });
        $$('[data-copy]').forEach(e => e.classList.toggle('active', Number(e.dataset.copy) === n));
        $$('[data-chapter]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.chapter) === n)));
        playActive();
      };
      const scrollScience = () => { const rect = track.getBoundingClientRect(), range = track.offsetHeight - stage.offsetHeight; const progress = Math.max(0, Math.min(.9999, -rect.top / Math.max(1, range))); activate(Math.min(2, Math.floor(progress * 3))); };
      let queued = false; on(window, 'scroll', () => { if (!queued) { queued = true; requestAnimationFrame(() => { scrollScience(); queued = false; }); } }, { passive: true });
      on(window, 'resize', scrollScience);
      $$('[data-chapter]').forEach(b => on(b, 'click', () => { const n = Number(b.dataset.chapter); const top = scrollY + track.getBoundingClientRect().top; const range = track.offsetHeight - stage.offsetHeight; window.scrollTo({ top: top + range * (n / 3 + .025), behavior: reduce.matches ? 'auto' : 'smooth' }); }));
      if (toggle) on(toggle, 'click', () => { paused = !paused; playActive(); });
      reduce.addEventListener('change', () => { paused = reduce.matches; playActive(); });
      on(document, 'visibilitychange', playActive);
      new IntersectionObserver(es => { scienceVisible = es[0].isIntersecting; document.body.classList.toggle('science-view', scienceVisible); playActive(); queueSticky(); }, { threshold: .15 }).observe(stage);
      activate(0); scrollScience();
    }

    /* ---- metric counters ---- */
    const countObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return; const e = entry.target;
        const target = Number(e.dataset.value), duration = Number(e.dataset.duration) || 1200, decimals = Number(e.dataset.decimals) || 0, prefix = e.dataset.prefix || '';
        countObserver.unobserve(e);
        if (reduce.matches) { e.textContent = prefix + target.toFixed(decimals); return; }
        e.textContent = prefix + (0).toFixed(decimals); let start;
        const tick = now => { if (!start) start = now; const t = Math.min(1, (now - start) / duration), val = target * (1 - Math.pow(1 - t, 3)); e.textContent = prefix + val.toFixed(decimals); if (t < 1) requestAnimationFrame(tick); };
        requestAnimationFrame(tick);
      });
    }, { threshold: .7 });
    $$('.count').forEach(e => countObserver.observe(e));

    /* ---- sticky fallback CTA (SOP 0e) ---- */
    const hero = $('.hero'), sticky = $('.sticky');
    const suppressors = $$('[data-sticky-suppress]');
    const inView = e => { const r = e.getBoundingClientRect(); return e.getClientRects().length > 0 && r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth; };
    function updateSticky() { if (!sticky) return; sticky.hidden = (hero && hero.getBoundingClientRect().bottom > 0) || scienceVisible || !!$('dialog[open]') || suppressors.some(inView); }
    let stickyQueued = false;
    function queueSticky() { if (!stickyQueued) { stickyQueued = true; requestAnimationFrame(() => { updateSticky(); stickyQueued = false; }); } }
    if (sticky) {
      if (window.IntersectionObserver) { const sio = new IntersectionObserver(queueSticky, { threshold: 0 }); [hero, ...suppressors].filter(Boolean).forEach(e => sio.observe(e)); }
      on(window, 'scroll', queueSticky, { passive: true }); on(window, 'resize', queueSticky);
      $$('details').forEach(e => on(e, 'toggle', queueSticky));
      $$('dialog').forEach(e => new MutationObserver(queueSticky).observe(e, { attributes: true, attributeFilter: ['open'] }));
      updateSticky();
    }

    /* ---- header cart badge sync on ANY cart mutation ---- */
    async function syncCartCount() {
      try { const c = await (await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })).json(); $$('[data-np-cart-count]').forEach(e => { e.textContent = c.item_count; e.hidden = !(c.item_count > 0); }); } catch (e) {}
    }
    if (!window.__soursopCartPatched) {
      window.__soursopCartPatched = true;
      const _fetch = window.fetch.bind(window);
      window.fetch = function (...args) { let u = args[0]; u = (u && u.url) ? u.url : u; const ret = _fetch(...args); if (typeof u === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(u)) ret.then(() => setTimeout(() => document.dispatchEvent(new CustomEvent('soursop:cartsync')), 90)).catch(() => {}); return ret; };
    }
    document.addEventListener('soursop:cartsync', syncCartCount);
    ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart:afterCartLoad'].forEach(ev => document.addEventListener(ev, syncCartCount));
    const bubble = document.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-count], .cart-count');
    if (bubble && window.MutationObserver) new MutationObserver(syncCartCount).observe(bubble, { childList: true, subtree: true, characterData: true });
    syncCartCount();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
